<template>
  <div class="notification-overlay flex-center flex-column">
    <template v-for="item in notificationList" :key="`notification-${item.id}`">
      <transition mode="out-in">
        <BaseNotification
          v-if="item.type === 'success'"
          type="success"
          with-emit
          :with-progress-bar="item.withTimer"
          class="flex-center calcContentWidth mb-5"
          inner-class="calcContentWidth"
          @close="closeNotification(item.id)"
        >
          <BaseIcon class="mr-5" icon-name="icon-success.svg" icon-color="green" is-without-hover="true" />
          <div>
            {{ item.content }}
          </div>
        </BaseNotification>
        <BaseNotification
          v-else-if="item.type === 'warning'"
          type="warning"
          with-emit
          :with-progress-bar="item.withTimer"
          class="flex-center calcContentWidth mb-5"
          inner-class="calcContentWidth"
          @close="closeNotification(item.id)"
        >
          <BaseIcon class="mr-5" icon-name="icon-warning.svg" icon-color="orange" is-without-hover="true" />
          <div>
            {{ item.content }}
          </div>
        </BaseNotification>
        <BaseNotification
          v-else-if="item.type === 'error'"
          type="error"
          with-emit
          :with-progress-bar="item.withTimer"
          class="flex-center calcContentWidth mb-5"
          inner-class="calcContentWidth"
          @close="closeNotification(item.id)"
        >
          <BaseIcon class="mr-5" icon-name="icon-error.svg" icon-color="red" is-without-hover="true" />
          <div>
            {{ item.content }}
          </div>
        </BaseNotification>
        <BaseNotification
          v-else-if="item.type === 'info'"
          type="info"
          with-emit
          :with-progress-bar="item.withTimer"
          class="flex-center calcContentWidth mb-5"
          inner-class="calcContentWidth"
          @close="closeNotification(item.id)"
        >
          <BaseIcon
            class="mr-5"
            icon-name="icon-info.svg"
            icon-color="blue"
            width="24px"
            height="24px"
            is-without-hover="true"
          />
          <div>
            {{ item.content }}
          </div>
        </BaseNotification>
      </transition>
    </template>
  </div>
</template>

<script lang="ts">
  import { useNotificationStore } from '@/store/notification'
  import { computed } from 'vue'
  import NotificationStore from '@/typescript/types/stores/NotificationStore'

  export default {
    name: 'IndexNotification',
    setup(props, { emit }) {
      const notificationStore: NotificationStore = useNotificationStore()
      // Anything raised with `asToast` belongs to BfToastViewport (03-components/11-toasts),
      // which a module mounts once it has migrated. Skipping them here is what keeps a single
      // message from being drawn twice, as a banner and as a toast.
      const notificationList = computed(() => notificationStore.getNotificationList.filter(item => !item.asToast))

      const { removeNotification } = notificationStore

      const closeNotification = (id: number) => {
        removeNotification(id)
        emit('close')
      }

      return {
        removeNotification,
        notificationList,
        closeNotification,
      }
    },
  }
</script>

<style scoped lang="scss">
  .notification-overlay {
    position: fixed;
    top: 100px;
    z-index: 100;
    width: 100%;
  }
</style>
